// @ts-ignore - Importazione di file JS senza tipi
import catalogIT from '../../langs/it/messages.js';
// @ts-ignore
import catalogFR from '../../langs/fr/messages.js';
import { BettingAPI } from './api/betting-api.js';
import { MasterUsersAPI } from './api/master-users-api.js';
import { makeReactive } from '../utils/reactive-store.js';

//> La lingua di default viene prelavata dalla url se spedita come parametro e risulta valida come formato
const urlParams = new URLSearchParams(window.location.search);
const langParam = urlParams.get('lang');

try {
    window.safeLocalStorage = window.localStorage;
} catch (e) {
    const DATA: Record<string, any> = {};
    window.safeLocalStorage = {
        getItem: (key: string) => DATA[key],
        setItem: (key: string, value: any) => DATA[key] = value
    } as Storage;
}

try {
    window.safeSessionStorage = window.sessionStorage;
} catch (e) {
    const DATA: Record<string, any> = {};
    window.safeSessionStorage = {
        getItem: (key: string) => DATA[key],
        setItem: (key: string, value: any) => DATA[key] = value
    } as Storage;
}

// Subito dopo il login il token di autenticazione viene comunicato tramite hash nella url
const hashAuthToken = window.location.hash.substring(1);

if (hashAuthToken !== '' && !hashAuthToken.startsWith("tgWebAppData")) {
    window.safeSessionStorage.setItem('SF-Auth-Token', hashAuthToken);
}

export interface ConfigInterface {
    AccountApiClass?: BettingAPI | MasterUsersAPI;
    masterUsersAPI: string;
    ccgAPI: string;
    publickey?: string; // Aggiunta se usata altrove
    requireOTP: boolean;
    telegramLogin?: string;
    softionAPI: string;
    softionAccountsAPI: string | null;
    softionLiveAPI: string;
    brTrackerAPI: (lang: string) => string;
    betting: {
        "odds-format": string;
        [key: string]: any;
    };
    statsURL: string;
    bettingDefaults: {
        waitPendingTickets: boolean;
        userAutoAcceptVariations: boolean;
    };
    currencySymbol: string;
    defaultCurrency: string; // Aggiunta se usata altrove
    cashoutEnable: boolean;
    cashoutLiveCommission: number | null;
    lang: string;
    langsettings: {
        catalogs: Record<string, any>;
    };
    minLiveOdd: number;
    allowedLiveSports: Record<string, boolean>;
    userMenuAsPopup?: boolean;
    allowP2P?: boolean;
    allowManualDeposit?: boolean;
    allowManualWithdraw?: boolean;
    liveTrackerType?: 'betradar'|'embedded-bc';
}

const Config: ConfigInterface = makeReactive({
    //> Va impostata a livello di configurazione per sito
    AccountApiClass: null, 

    masterUsersAPI: 'https://master-users.betfire.com',
    ccgAPI: 'https://ccg-api.sportstats.eu/betting/wadmin',
    requireOTP: false,

    defaultCurrency: 'USD',

    softionAPI: "https://if-europa.betsystem.org", 
    softionAccountsAPI: null, 
    softionLiveAPI: 'wss://unified-live.betfire.com/test/ws/live-feed', 
    brTrackerAPI: (lang: string) => `https://href.li/?https://cs.betradar.com/ls/widgets/?/eplay24/${lang}/Europe:Berlin/page/widgets_lmts#matchId=`,
    betting: { // Questi si sovrascrivono ad ogni chiamata a /betting/settings o /prematch/settings
        "odds-format": "decimal",
    },
	statsURL: 'https://stats.961bet.live/eventstats/{code}',
	bettingDefaults: {
		// waitPendingTickets: Se impostato a true blocca tutte le scommesse finché la riserva non ha accettato/rifiutato le giocate
		waitPendingTickets: true,
		// userAutoAcceptVariations: la chackbox per accetta variazioni di default deve essere flaggata.
		userAutoAcceptVariations: true
    },
	currencySymbol: "Birr",
    cashoutEnable: false,
    cashoutLiveCommission: null, // 20, //> Commissione percentuale (da 1 a 100) cashout live
    lang: langParam !== null && /^([a-zA-Z]{2})$/.test(langParam) ? langParam : "it",
    langsettings: {
        catalogs: {
            it: catalogIT,
            fr: catalogFR
        }
    },
	minLiveOdd: 1.00, // Sotto questo valore, il live mostra sempre 0.00; se metti 1.00 la funzione si disabilita
    allowedLiveSports: {
        '/sport/1':true,
        '/sport/2':true,
        '/sport/3':true,
        '/sport/4':true,
        '/sport/5':true,
        '/sport/6':true,
        '/sport/7':true,
        '/sport/8':true,
        '/sport/9':true,
        '/sport/10':true,
        '/sport/11':true,
        '/sport/12':true,
        '/sport/13':true,
        '/sport/14':true,
        '/sport/15':true,
        '/sport/16':true,
        '/sport/17':true,
        '/sport/18':true,
        '/sport/19':true,
        '/sport/20':true,
        '/sport/21':true,
        '/sport/22':true,
        '/sport/23':true,
        '/sport/24':true,
        '/sport/25':true,
        '/sport/26':true,
        '/sport/27':true,
        '/sport/28':true,
        '/sport/29':true,
        '/sport/30':true,
        '/sport/31':true,
        '/sport/32':true,
        '/sport/33':true,
        '/sport/34':true,
        '/sport/35':true,
        '/sport/36':true,
        '/sport/37':true,
        '/sport/38':true,
        '/sport/39':true,
        '/sport/40':true,
        '/sport/41':true,
        '/sport/42':true,
        '/sport/43':true,
        '/sport/44':true,
        '/sport/45':true,
        '/sport/46':true,
        '/sport/47':true,
        '/sport/48':true,
        '/sport/49':true,
        '/sport/50':true,
        '/sport/51':true,
        '/sport/52':true,
        '/sport/53':true,
        '/sport/54':true,
        '/sport/55':true,
        '/sport/56':true,
        '/sport/57':true,
        '/sport/58':true,
        '/sport/59':true,
        '/sport/60':true,
        '/sport/61':true,
        '/sport/62':true,
        '/sport/63':true,
        '/sport/64':true,
        '/sport/65':true,
        '/sport/66':true,
        '/sport/67':true,
        '/sport/68':true,
        '/sport/69':true,
        '/sport/70':true,
        '/sport/71':true,
        '/sport/72':true,
        '/sport/73':true,
        '/sport/74':true,
        '/sport/75':true,
        '/sport/76':true,
        '/sport/77':true,
        '/sport/78':true,
        '/sport/79':true,
        '/sport/80':true,
        '/sport/81':true,
        '/sport/82':true,
        '/sport/83':true,
        '/sport/84':true,
        '/sport/85':true,
        '/sport/86':true,
        '/sport/87':true,
        '/sport/88':true,
        '/sport/89':true,
        '/sport/90':true,
        '/sport/91':true,
        '/sport/92':true,
        '/sport/93':true,
        '/sport/94':true,
        '/sport/95':true,
        '/sport/96':true,
        '/sport/97':true,
        '/sport/98':true,
        '/sport/99':true,
        '/sport/100':true,
        '/sport/101':true,
        '/sport/102':true,
        '/sport/103':true,
        '/sport/104':true,
        '/sport/105':true,
        '/sport/106':true,
        '/sport/107':true,
        '/sport/108':true,
        '/sport/109':true,
        '/sport/110':true,
        '/sport/111':true,
        '/sport/112':true,
        '/sport/113':true,
        '/sport/114':true,
        '/sport/115':true,
        '/sport/116':true,
        '/sport/117':true,
        '/sport/118':true,
        '/sport/119':true,
        '/sport/120':true,
        '/sport/121':true,
        '/sport/122':true,
        '/sport/123':true,
        '/sport/124':true,
        '/sport/125':true,
        '/sport/126':true,
        '/sport/127':true,
        '/sport/128':true,
        '/sport/129':true,
        '/sport/130':true,
        '/sport/131':true,
        '/sport/132':true,
        '/sport/133':true,
        '/sport/134':true,
        '/sport/135':true,
        '/sport/136':true,
        '/sport/137':true,
        '/sport/138':true
    }
});

export default Config;